import * as actionTypes from './actionTypes';

export const showModal = ({ modalProps, modalType }) => dispatch => {
  dispatch({
    type: actionTypes.SHOW_MODAL,
    modalProps: modalProps,
    modalType: modalType
  })
}

export const hideModal = () => dispatch => {
  dispatch({
    type: actionTypes.HIDE_MODAL
  })
}



// WEBPACK FOOTER //
// ./src/store/actions/modals.js